import {useFlag} from '@unleash/proxy-client-react';

const useVenmoCashFundFlag = () => useFlag('web-venmo-cash-fund');

export default useVenmoCashFundFlag;
